module.exports = __webpack_public_path__ + "img/202304-xs.3c990f2f.png";